import { useDispatch } from 'react-redux'
import { UseQueryResult, useMutation, useQuery } from '@tanstack/react-query'
import { getShopWOMPlus, updateShopWOMPlus } from 'app/shops/state/actions'
import { IShopWOMPlus } from '@cbgms/api'

const cacheKey = 'WOMPlusSetting'

const STALE_TIME = 5 * 60 * 1000
const CACHE_TIME = 10 * 60 * 1000

export const useGetWOMPlusSetting = (shopID: string): UseQueryResult<IShopWOMPlus> => {
  const dispatch = useDispatch()

  return useQuery(
    [cacheKey, shopID],
    async () => {
      const { Data } = await dispatch(getShopWOMPlus(shopID))
      return Data
    },
    {
      enabled: !!shopID,
      refetchOnWindowFocus: false,
      staleTime: STALE_TIME,
      cacheTime: CACHE_TIME
    }
  )
}

interface IUpdateWOMPlus {
  data: Partial<IShopWOMPlus>
}

export const useUpdateWOMPlusSettings = (shopID: string) => {
  const dispatch = useDispatch()

  return useMutation(async (womPlus: IUpdateWOMPlus) => {
    const { data } = womPlus
    return dispatch(updateShopWOMPlus(shopID, data))
  })
}
